<template>
    <div class="carousel-container">
      <stack :column-min-width="200" :gutter-width="15" :gutter-height="15" monitor-images-loaded>
        <stack-item class="img-container"  v-for="(slide, index) in this.model.content" :key="index" style="transition: transform 300ms">
            <display-image
              :imageId="slide.id"
              :width="images[normalizeIndex(index)].height"
              :height="images[normalizeIndex(index)].width"
              :contain="true"
          />
      </stack-item>
    </stack>
    </div>
</template>
<script>

import { Stack, StackItem } from 'vue-stack-grid'
import DisplayImage from '../_shared/DisplayImage.vue'

export default {
  name: 'ContentTypeGrid',
  components: { Stack, StackItem, DisplayImage },
  props: ['model'],
  data() {
    return {
      images: [
        { height: 350, width: 150 },
        { height: 300, width: 500 },
        { height: 400, width: 200 },
        { height: 200, width: 200 },
        { height: 400, width: 400 },
        { height: 200, width: 200 },
        { height: 500, width: 500 },
        { height: 300, width: 250 },
        { height: 300, width: 300 },
        { height: 300, width: 250 },
        { height: 400, width: 200 },
        { height: 250, width: 300 },
        { height: 400, width: 200 },
        { height: 200, width: 200 },
        { height: 350, width: 150 },
        { height: 300, width: 500 },
        { height: 400, width: 200 },
        { height: 200, width: 200 },
        { height: 400, width: 400 },
        { height: 300, width: 250 },
        { height: 400, width: 200 },
        { height: 500, width: 200 },
        { height: 200, width: 300 },
        { height: 300, width: 300 }
      ]
    }
  },
  methods: {
    normalizeIndex(index) {
      const length = this.images.length
      return (length + (index % length)) % length
    }
  }
}
</script>
<style>

.img-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: center;
  overflow: hidden;
  margin: 0;
  object-fit: fill;
  padding: 5px;

}
.img-container img {
  display: block;
  margin: 0;
  width: 100%;
  height: auto;

}
.img-container figcaption {
  margin: 3px 0;
  text-align: center;
}
</style>
